import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DateInputCustomFormatPlaceholder } from '@progress/kendo-angular-dateinputs';
import {
  GridComponent,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
import {
  ContextMenuComponent,
  ContextMenuSelectEvent,
} from '@progress/kendo-angular-menu';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SVGIcon, moreVerticalIcon, plusIcon } from '@progress/kendo-svg-icons';
import { head, includes, some } from 'lodash';
import moment from 'moment';
import { combineLatest } from 'rxjs';
import { FormatDate } from 'src/app/core/pipes/format-date.pipe';
import { EITransitionService } from 'src/app/services/ei-transition.service';
import { ReferenceService } from 'src/app/services/reference.service';
import { ReferralsService } from 'src/app/services/referrals.service';
import { RoutesConstantService } from 'src/app/services/routes-constant.service';
import { StudentService } from 'src/app/services/student.service';
import { atsPreschoolGrades } from 'src/app/shared/constants/ats-preschool-grades';
import {
  DOB_MIN_DATE,
  DOB_MIN_MONTH,
  DOB_MIN_YEAR,
} from 'src/app/shared/constants/date-constants';
import {
  dialogAnimationDuration,
  dialogTimer,
} from 'src/app/shared/constants/dialog-specs';
import {
  DATE_OF_BIRTH_MISSING,
  MANDATED_THREE_YEAR_REEVALUATION_TEXT,
  NEW_ADDITIONAL_REEVALUATION_TEXT,
  NEW_REEVALUATION,
  NOTIFICATION_MESSAGES,
  OUTSTANDING_ASSESSMENTS_TEXT,
} from 'src/app/shared/constants/notification-messages';
import { Permissions } from 'src/app/shared/enums/permissions';
import { getReferenceDataById } from 'src/app/shared/functions/get-reference-data-by-id';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { DropdownOption } from 'src/app/shared/interfaces/dropdown-option';
import { IAddChildReferenceData } from 'src/app/shared/interfaces/form/add-child-reference-data.model';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
import { ISedmsFormOutput } from 'src/app/shared/interfaces/form/sedms-form-output.model';
import {
  StudentActions,
  StudentInfo,
} from 'src/app/shared/interfaces/student-info';
import { Location } from 'src/app/shared/models/location';
import { Permission } from 'src/app/shared/models/permission';
import { User } from 'src/app/shared/models/user';
import { validateName } from 'src/app/shared/validators/validator';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { StudentStore } from 'src/app/stores/student.store';
import { EiAddStudent } from '../ei-transition/models/ei-add-student.model';
import {
  IepMeasurable,
  IepTypeAdd,
} from '../iep/iep-document/interfaces/iep-type';
import { IEPService } from '../iep/iep-document/services/iep.services';
import {
  AddReferralRequest,
  ReferralInfo,
  ReferralSource,
  ReferralType,
} from '../referrals/interfaces/referrals.model';
import { ParentGuardianDetailsResponse } from '../verification-guardian-parent-child/models/parent-guardian-details-response.model';
import { VerificationGuardianParentChildService } from '../verification-guardian-parent-child/services/verification-guardian-parent-child.service';
import {
  ACTIVE,
  ACTIVE_STATUS_CODE,
  APRIL,
  APRIL_FIRST,
  CHILD_WILL_BE_ELIGIBLE_FOR_INITIAL_REFERRAL_STARTING_TEXT,
  CLOSED,
  DAY_FOUR,
  DAY_ONE,
  DBN_ARRAY_LENGTH,
  DBN_FIRST_INDEX,
  DISCHARGED,
  DISCHARGED_STATUS_CODE,
  EI_ID_LENGTH_SEVEN,
  EI_ID_LENGTH_SIX,
  JULY,
  MARCH,
  MARCH_FOURTH,
  NEW_REFERRAL_STATUS,
  NYC_ID_LENGTH_NINE,
  NYC_ID_LENGTH_SEVEN,
  NYC_ID_LENGTH_SIX,
  OCTOBER,
  OCTOBER_FIRST,
  REQUEST_FOR_REEVALUATION_STATUS,
  SEPTEMBER,
  SEPTEMBER_FOURTH,
  STUDENT_FIRST_AND_LAST_NAME_LENGTH,
  THREE_YEARS,
  TWO_YEARS,
} from './constants/student-search-constants';
import { MenuItemText } from './enum/menu-item-text';
import {
  LinkParentwithChildRequest,
  StudentSearchParams,
} from './models/student-search-interface';
import { FormDetails, StudentSearchModel } from './models/student-search-model';

@Component({
  selector: 'app-student-search',
  templateUrl: './student-search.component.html',
  styleUrls: ['./student-search.component.scss'],
  providers: [FormatDate],
  standalone: false,
})
export class StudentSearchComponent implements OnChanges, OnInit {
  @Input() showSearchModal: boolean = false;
  @Input() type: string;
  @Input() newReferral: boolean = false;
  @Input() isEISearch: boolean = false;
  @Input() showCreateStudentBtn: boolean = true;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() parentGuardianDetails: ParentGuardianDetailsResponse;
  showResults: boolean = false;
  searchFormGroup!: FormGroup;
  students: StudentInfo[] = [];
  gradeList: DropdownOption[];
  isPreSchool: boolean = false;
  public mySelection: string[] = [];
  emptySearchMsg: boolean;
  readonly referralStatus: number = 10;
  dbnList: DropdownOption[] = [
    {
      id: 0,
      description: '',
    },
    {
      id: 1,
      description: '22K700',
    },
    {
      id: 2,
      description: '03M700',
    },
    {
      id: 3,
      description: '28Q700',
    },
    {
      id: 4,
      description: '17K700',
    },
    {
      id: 5,
      description: '11X700',
    },
    {
      id: 6,
      description: '09X700',
    },
    {
      id: 7,
      description: '32K700',
    },
    {
      id: 8,
      description: '24Q700',
    },
  ];
  showNewStudentDialog: boolean = false;
  svgPlus: SVGIcon = plusIcon;
  public showCreate: boolean = false;

  loading: boolean = false;
  user: User;

  currentStudent?: EiAddStudent;
  eiReferenceData: IAddChildReferenceData;
  showCreateLinkStudent: boolean;
  emptyStudentLink: boolean;
  loadCreateLinkStudentSpinner: boolean;
  formSubmitted: boolean = false;
  readonly pageSize: number = 10;
  readonly responseLength: number = 0;

  public dataItem: StudentActions;
  @ViewChild('gridmenu') public gridContextMenu: ContextMenuComponent;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChildren('anchor') public anchorRefs!: QueryList<
    ElementRef<HTMLButtonElement>
  >;
  component: {
    homeDistrict: IReferenceData[];
    languages: IReferenceData[];
    state: IReferenceData[];
    borough: IReferenceData[];
    grades: IReferenceData[];
    locations: IReferenceData[];
    reasons: IReferenceData[];
    otherReferralReasons: IReferenceData[];
    relationships: IReferenceData[];
    suffixes: IReferenceData[];
    fosterAgencies: IReferenceData[];
    eiDocumentTypes: IReferenceData[];
    eiAeConditions: IReferenceData[];
    agency: IReferenceData[];
  };
  public minDOB: Date = new Date(DOB_MIN_YEAR, DOB_MIN_MONTH, DOB_MIN_DATE);
  public maxDOB: Date = new Date();
  public selectableSettings: SelectableSettings = {
    checkboxOnly: false,
    mode: 'single',
    drag: false,
  };
  public formatPlaceholder: DateInputCustomFormatPlaceholder = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY',
    hour: 'h',
    minute: 'm',
    second: 's',
  };
  public actionIcon: SVGIcon = moreVerticalIcon;

  public show: string = '';

  // ATS status codes:
  activeStatusCode: string = ACTIVE_STATUS_CODE;
  active: string = ACTIVE;

  dischargedStatusCode: string = DISCHARGED_STATUS_CODE;
  discharged: string = DISCHARGED;

  closed: string = CLOSED;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public studentService: StudentService,
    public routesConstantService: RoutesConstantService,
    private referenceService: ReferenceService,
    private referenceStore: ReferenceStore,
    private studentStore: StudentStore,
    private notificationService: NotificationService,
    private authStore: AuthStore,
    private eiTransitionService: EITransitionService,
    private cdref: ChangeDetectorRef,
    private formatDate: FormatDate,
    private verificationService: VerificationGuardianParentChildService,
    private referralsService: ReferralsService,
    private iepService: IEPService<ISedmsFormOutput>
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.eiReferenceData && !this.gradeList && changes.showSearchModal) {
      const currentValue: boolean = changes.showSearchModal.currentValue;
      const previousValue: boolean = changes.showSearchModal.previousValue;

      // Check if the boolean input has turned true
      if (currentValue === true && previousValue === false) {
        this.getEIReferenceData();
        this.getGrades();
      }
    }
  }

  setDbn(): void {
    // this.searchFormGroup.get('dbn').patchValue(this.dbnList.length == 1 && dbn ? [1] : [])
    this.searchFormGroup.get('dbn').patchValue(head(this.dbnList).description);
  }

  public selectStudent(): void {
    this.mySelection = [...this.mySelection];
  }

  public expandDetailsBy: (dataItem: StudentInfo) => string = (
    dataItem: StudentInfo
  ) => {
    return dataItem.nycId!;
  };

  public toggle(id: string): void {
    if (this.show === id) {
      this.show = '';
    } else {
      this.show = id;
    }
  }

  ngOnInit(): void {
    this.user = this.authStore.UserInfo;
    this.createForm();
    if (this.user) this.setDbn();
    this.authStore.UserInfo$.subscribe((userInfo: User) => {
      this.user = userInfo;
      this.setDbn();
    });
    if (this.type === 'createLinkStudent') {
      this.showCreateLinkStudent = true;
      this.emptyStudentLink = false;
    }
  }

  public openMenu(dataItem: StudentInfo, rowIndex: number): void {
    this.dataItem = {
      ...dataItem,
      rowIndex,
      actions: this.getContextMenuItems(dataItem),
    } as StudentActions;
    const targetButton: ElementRef<HTMLButtonElement> = this.anchorRefs
      .toArray()
      ?.at(rowIndex % this.pageSize);

    if (targetButton) {
      this.gridContextMenu.show(targetButton);
    }
  }

  private getContextMenuItems(dataItem: StudentInfo) {
    const items: { text: string }[] = [];

    // The `View student profile` option is always shown
    items.push({ text: MenuItemText.ViewStudentProfile });

    if (dataItem.refStatus === NEW_REFERRAL_STATUS) {
      items.push({ text: MenuItemText.ViewClosedReferral });
    }
    if (
      this.canCreateStudent() &&
      !!dataItem.eiId &&
      !dataItem.nycId &&
      (dataItem.refStatus === null ||
        dataItem.refStatus === NEW_REFERRAL_STATUS) &&
      !dataItem.hasIEP &&
      !dataItem.ineligibleSE
    ) {
      items.push({ text: MenuItemText.CreateNewStudent });
    }
    if (
      (((dataItem.refStatus === null ||
        dataItem.refStatus === NEW_REFERRAL_STATUS) &&
        !dataItem.hasIEP) ||
        dataItem.isActive === false) &&
      dataItem.nycId &&
      !dataItem.ineligibleSE
    ) {
      items.push({ text: MenuItemText.ContinueNewReferralScreen });
    }
    if (
      (((dataItem.refStatus === null ||
        dataItem.refStatus === this.referralStatus) &&
        !dataItem.hasIEP) ||
        dataItem.isActive === false) &&
      dataItem.nycId &&
      !dataItem.ineligibleSE
    ) {
      // Restrict CSP flow for children under 3 years old. If DOB is available,
      // compute age and only allow CSP when age >= 3. If DOB is not available,
      // fall back to existing behavior (allow CSP).
      const dob = dataItem.dateOfBirth || (dataItem.birthDate ? dataItem.birthDate : null);
      const isAtLeastThreeYearsOld = dob ? moment().diff(moment(dob), 'years') >= 3 : true;
      if (isAtLeastThreeYearsOld) {
        items.push({ text: MenuItemText.ContinueWithCSP });
      }
    }
    if (
      dataItem.isActive === true &&
      dataItem.hasIEP &&
      !dataItem.isM3Y &&
      !dataItem.hasRRE &&
      dataItem.refStatus === NEW_REFERRAL_STATUS &&
      !dataItem.ineligibleSE &&
      some(
        this.user?.selectedRole?.userPermissions,
        (x: Permission) => x.permissionId === Permissions.CanCreateRequestforReevaluation)
    ) {
      items.push({ text: MenuItemText.CreateRequestForReevaluation });
    }
    if (
      dataItem.isActive === true &&
      dataItem.hasRRE &&
      dataItem.refStatus === NEW_REFERRAL_STATUS &&
      !dataItem.ineligibleSE &&
      some(
        this.user?.selectedRole?.userPermissions,
        (x: Permission) => x.permissionId === Permissions.CanCreateRequestforAdditionalReevaluation)
    ) {
      items.push({
        text: MenuItemText.CreateRequestForAdditionalReevaluation,
      });
    }
    if (
      dataItem.isM3Y &&
      dataItem.refStatus === NEW_REFERRAL_STATUS &&
      !dataItem.ineligibleSE &&
      some(
        this.user?.selectedRole?.userPermissions,
        (x: Permission) => x.permissionId === Permissions.CanAddReferralRecords)
    ) {
      items.push(
        { text: MenuItemText.CreateMandatedThreeYearReevaluation },
        { text: MenuItemText.WaiveMandatedThreeYearReevaluation }
      );
    }
    if (this.showCreateLinkStudent) {
      items.push({ text: MenuItemText.CreateLinkStudent });
    }

    return items;
  }

  onSelect(menuItem: ContextMenuSelectEvent): void {
    switch (menuItem.item.text) {
      case MenuItemText.ViewClosedReferral:
        if (this.dataItem.referralType === REQUEST_FOR_REEVALUATION_STATUS) {
          this.viewReferralRequestReevaluation(
            this.dataItem.referralSk,
            this.dataItem.nycId
          );
        } else {
          this.viewReferralRequest(
            this.dataItem.referralSk,
            this.dataItem.nycId
          );
        }
        break;
      case MenuItemText.ContinueNewReferralScreen:
        this.openInitReferralRequest(this.dataItem);
        break;
      case MenuItemText.ContinueWithCSP:
        this.onSelectContinueWithCSP();
        break;
      case MenuItemText.ViewStudentProfile:
        this.openStudentProfile(this.dataItem);
        break;
      case MenuItemText.CreateNewStudent:
        this.addNewStudent(true, this.dataItem.eiStudentSk);
        break;
      case MenuItemText.CreateRequestForReevaluation:
      case MenuItemText.CreateRequestForAdditionalReevaluation:
      case MenuItemText.CreateRequestForMandatedThreeYearReevaluation:
        this.initiateRequestForRevaluation(this.dataItem);
        break;
      case MenuItemText.CreateMandatedThreeYearReevaluation:
        this.openM3YReeval(this.dataItem);
        break;
      case MenuItemText.WaiveMandatedThreeYearReevaluation:
        this.waiveM3YReeval(this.dataItem);
        break;
      case MenuItemText.CreateLinkStudent: {
        this.loadCreateLinkStudentSpinner = true;

        const formDetails: FormDetails = {
          linkSk: this.parentGuardianDetails?.linkSk,
          guardianId: this.parentGuardianDetails?.guardianId,
          studentSk: this.dataItem?.studentSk,
          nycid: String(this.dataItem?.nycId),
          studentDBN: this.dataItem?.schoolDBN,
          parentFname: this.parentGuardianDetails?.parentFname,
          parentLname: this.parentGuardianDetails?.parentLname,
          parentEmail: this.parentGuardianDetails?.parentEmail,
          parentPhone: this.parentGuardianDetails?.parentPhone,
          address1: this.dataItem?.address1,
          address2: this.dataItem?.address2,
          city: this.dataItem?.city,
          state: this.dataItem?.state,
          zip: this.dataItem?.zip,
          relationToChild: getReferenceDataById(
            this.parentGuardianDetails?.relationToChild,
            this.eiReferenceData.relationships
          )?.value,
          reasonforReferral: this.parentGuardianDetails?.reasonforReferral,
          otherReferralReason: this.parentGuardianDetails?.otherReferralReason,
          referralType: ReferralType.InitialReferral,
        };
        this.verificationService
          .addLinkParentwithChild(formDetails)

          .subscribe((data: LinkParentwithChildRequest) => {
            if (data?.isRequestSucessful) {
              this.notificationService.show({
                content: NOTIFICATION_MESSAGES.submitSuccess,
                cssClass: 'notification-success',
                hideAfter: dialogTimer,
                position: { horizontal: 'center', vertical: 'top' },
                animation: { type: 'slide', duration: dialogAnimationDuration },
                type: { style: 'success', icon: true },
              });
              this.students = [];
              this.loadCreateLinkStudentSpinner = false;
              this.showResults = false;
              this.closeModal.next();
              this.router.navigate([
                this.routesConstantService.routes.ParentPortalRequestsGrid,
              ]);
            }
          });
        break;
      }
    }
  }
  onSelectContinueWithCSP(): void {
    const payload: AddReferralRequest = new AddReferralRequest();
    payload.atsDischargeCode = this.dataItem.atsDischargeCode;
    payload.atsStatus = this.dataItem.atsStatus;
    payload.caseCloseDate = this.dataItem.caseCloseDate;
    payload.closeCase = this.dataItem.closeCase;
    payload.dateOfBirth = this.dataItem.dateOfBirth;
    payload.dateOfBirthUnixTimestamp = this.dataItem.dateOfBirthUnixTimestamp;
    payload.eiId = this.dataItem.eiId;
    payload.eiStudentSk = this.dataItem.eiStudentSk;
    payload.gender = this.dataItem.gender;
    payload.grade = this.dataItem.grade;
    payload.hasEvals = this.dataItem.hasEvals;
    payload.hasIEP = this.dataItem.hasIEP;
    payload.hasRRE = this.dataItem.hasRRE;
    payload.id = this.dataItem.eiId;
    payload.ineligibleSE = this.dataItem.ineligibleSE;
    payload.isActive = this.dataItem.isActive;
    payload.isM3Y = this.dataItem.isM3Y;
    payload.isPreSchool = this.dataItem.isPreSchool;
    payload.isSpecialEd = this.dataItem.isSpecialEd;
    payload.noOfClosures = this.dataItem.noOfClosures;
    payload.StudentOSISId = this.dataItem.nycId;
    payload.nycId = this.dataItem.nycId;
    payload.reasonforCaseclose = this.dataItem.reasonforCaseclose;
    payload.refStatus = this.dataItem.refStatus;
    payload.refStatusName = this.dataItem.refStatusName;
    payload.referralSk = this.dataItem?.referralSk;
    payload.referralType = 20;
    payload.rowIndex = this.dataItem.rowIndex;
    payload.school = this.dataItem.school;
    payload.schoolDBN = this.dataItem.schoolDBN;
    payload.studentName = this.dataItem.studentName;
    payload.studentSk = this.dataItem.studentSk;
    payload.studentStatus = this.dataItem.studentStatus;
    payload.caseManagerPerson =
      this.user !== undefined ? this.user.personSk : null;
    const refsource: ReferralSource = new ReferralSource();
    refsource.firstName = '';
    refsource.lastName = '';
    refsource.middleName = '';
    refsource.personType = null;
    refsource.email = '';
    refsource.personSk =
      this.dataItem?.personSk ?? this.authStore.UserInfo.personSk;
    refsource.phone = '';
    refsource.title = '';
    refsource.personTypeText = '';
    refsource.role = '';
    refsource.personCategoryText = '';
    payload.referralSource = refsource;

    //api

    const payloadForIEP: IepTypeAdd = new IepTypeAdd();
    payloadForIEP.id = this.dataItem.id;
    payloadForIEP.studentSK = this.dataItem.studentSk;
    payloadForIEP.referralSK = this.dataItem.referralSk;
    payloadForIEP.iepFormSK = this.dataItem.iepFormSK;
    payloadForIEP.iepMeetingDate = this.dataItem.iepMeetingDate;
    payloadForIEP.latestIepMeetingDate = this.dataItem.latestIepMeetingDate;
    payloadForIEP.iepType = 'CSP';
    payloadForIEP.projectedAnnRevDate = this.dataItem.projectedAnnRevDate;
    payloadForIEP.meetsOtherDef = this.dataItem.meetsOtherDef;
    payloadForIEP.projectedNxtManThreeYrRevalDate =
      this.dataItem.projectedNxtManThreeYrRevalDate;
    payloadForIEP.iepAmendment = this.dataItem.iepAmendment;
    payloadForIEP.reconveneIEPMeeting = this.dataItem.reconveneIEPMeeting;
    payloadForIEP.disability = this.dataItem.disability;
    payloadForIEP.specialEdServ = this.dataItem.specialEdServ;
    payloadForIEP.lackInstructMath = this.dataItem.lackInstructMath;
    payloadForIEP.lackOutstructReading = this.dataItem.lackOutstructReading;
    payloadForIEP.limitedEnglishProf = this.dataItem.limitedEnglishProf;
    payloadForIEP.otherImpairment = this.dataItem.otherImpairment;
    payloadForIEP.otherImpairementDesc = this.dataItem.otherImpairementDesc;
    payloadForIEP.disabilityClass = this.dataItem.disabilityClass;
    payloadForIEP.requiresSpecEd = this.dataItem.requiresSpecEd;
    payloadForIEP.medicalCondition = this.dataItem.medicalCondition;
    payloadForIEP.physicalLimit = this.dataItem.physicalLimit;
    payloadForIEP.learning = this.dataItem.learning;
    payloadForIEP.behavior = this.dataItem.behavior;
    payloadForIEP.participation = this.dataItem.participation;
    payloadForIEP.reqMedicalCare = this.dataItem.reqMedicalCare;
    payloadForIEP.reqHealthCare = this.dataItem.reqHealthCare;
    payloadForIEP.lastModuser = this.dataItem.lastModuser;
    payloadForIEP.lastModTs = this.dataItem.lastModTs;
    payloadForIEP.isLocked = this.dataItem.isLocked;
    payloadForIEP.isSubmit = this.dataItem.isSubmit;
    payloadForIEP.typeOfMeeting = 1;
    payloadForIEP.meetingsk = this.dataItem.meetingsk;
    payloadForIEP.inEligibilitySk = this.dataItem.inEligibilitySk;
    payloadForIEP.declassficationSk = this.dataItem.declassficationSk;
    payloadForIEP.isAnnual = this.dataItem.isAnnual;
    payloadForIEP.referenceIEPFormsk = this.dataItem.referenceIEPFormsk;
    payloadForIEP.previousIEP = this.dataItem.previousIEP;
    payloadForIEP.iepStatus = this.dataItem.iepStatus;

    this.loading = true;
    this.referralsService.AddorUpdateReferral(payload, '').subscribe({
      next: (response: ApiResponse<ReferralInfo>) => {
        if (response) {
          payloadForIEP.referralSK = response.value.referralSk;
          payloadForIEP.studentSK = response?.value?.studentSK;
          this.iepService
            .addIepTypeAsCSP({ ...payloadForIEP, dob: payload.dateOfBirth } as any)
            .subscribe({
              next: (response: any) => {
                this.notificationService.show({
                  content: 'IEP successfully created',
                  cssClass: 'notification-success',
                  hideAfter: dialogTimer,
                  position: { horizontal: 'center', vertical: 'top' },
                  animation: {
                    type: 'slide',
                    duration: dialogAnimationDuration,
                  },
                  type: { style: 'success', icon: true },
                });
                this.loading = false;
                this.closeModal.next();
                this.iepMeasuableAnnualGoal(
                  payload.StudentOSISId ?? payload.nycId,
                  response.value.iepFormSK
                );
              },
              error: () => {
                this.notificationService.show({
                  content: 'Error while updating IEP type as CSP',
                  cssClass: 'notification-error',
                  hideAfter: dialogTimer,
                  position: { horizontal: 'center', vertical: 'top' },
                  animation: {
                    type: 'slide',
                    duration: dialogAnimationDuration,
                  },
                  type: { style: 'error', icon: true },
                });
                this.loading = false;
              },
            });
        } else {
          this.notificationService.show({
            content: 'Error while creating referral',
            cssClass: 'notification-error',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'error', icon: true },
          });
          this.loading = false;
        }
      },
      error: () => {
        this.notificationService.show({
          content: 'Error while creating referral (server error)',
          cssClass: 'notification-error',
          hideAfter: dialogTimer,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: dialogAnimationDuration },
          type: { style: 'error', icon: true },
        });
        this.loading = false;
      },
    });
  }
  iepMeasuableAnnualGoal(nycId: string, iepFormSK: string): void {
    this.loading = true;
    const temp: IepMeasurable = new IepMeasurable();
    // temp.annualGoalSeq = null;
    temp.iepFormSK = iepFormSK;

    const payload: IepMeasurable = {
      iepFormSk: iepFormSK,
      isLocked: false,
      isSubmit: false,
      actionType: 1,
      operationType: 1,
      goals: [
        {
          annualGoalSeq: null,
          criteria: '<p>dummy</p>',
          method: '<p>dummy</p>',
          frequency: 1,
          freqInterval: 5,
          goalNarrative: 'dummy',
          freqIntervalOther: null,
          operationType: 1,
          otherFrequency: null,
          objectives: [],
        },
      ],
    };
    this.iepService.IEPMeasuableAnnualGoal(payload as any).subscribe({
      next: () => {
        this.router.navigate([
          this.routesConstantService.routes.addiepdocument +
          nycId +
          '/' +
          iepFormSK +
          '/edit/Recommended-program-and-services-CSP',
        ]);
        this.loading = false;
      },
      error: () => {
        this.notificationService.show({
          content: 'Failed to save measurable annual goal. Please try again.',
          cssClass: 'error-notification',
          animation: { type: 'fade', duration: 400 },
          position: { horizontal: 'center', vertical: 'top' },
          type: { style: 'error', icon: true },
        });
        this.loading = false;
      },
    });
  }
  public createForm(): void {
    this.emptySearchMsg = false;
    this.searchFormGroup = this.fb.group({
      nycid: new FormControl('', [this.nycidValidator()]),
      firstName: new FormControl('', validateName(false)),
      lastName: new FormControl('', validateName(false)),
      dob: new FormControl(''),
      grade: new FormControl(''),
      dbn: new FormControl(
        this.dbnList.length > DBN_ARRAY_LENGTH
          ? this.dbnList[DBN_FIRST_INDEX].description
          : []
      ), //TODO: adjust to the other instantiation way, without using new FormControl
    });
    if (this.type === 'createLinkStudent') {
      this.searchFormGroup
        .get('firstName')
        .setValidators([Validators.required]);
      this.searchFormGroup.get('firstName').updateValueAndValidity();

      this.searchFormGroup.get('lastName').setValidators([Validators.required]);
      this.searchFormGroup.get('lastName').updateValueAndValidity();

      this.searchFormGroup.get('dob').setValidators([Validators.required]);
      this.searchFormGroup.get('dob').updateValueAndValidity();
    }
  }

  nycidValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value ? control.value.toString() : '';
      if (
        !value ||
        value.length === NYC_ID_LENGTH_SIX ||
        value.length === NYC_ID_LENGTH_SEVEN ||
        value.length === NYC_ID_LENGTH_NINE
      ) {
        return null;
      }
      return { invalidNycid: true };
    };
  }

  getGrades(): void {
    this.referenceStore.grade$.subscribe((response: IReferenceData[]) => {
      this.gradeList = response;
    });
  }

  getDbns(): void {
    this.referenceStore.dbn$.subscribe((response: IReferenceData[]) => {
      this.dbnList = response;
    });
  }

  getEIReferenceData(): void {
    combineLatest([
      this.referenceStore.district$,
      this.referenceStore.language$,
      this.referenceStore.state$,
      this.referenceStore.borough$,
      this.referenceStore.fosterAgency$,
      this.referenceStore.relationship$,
      this.referenceStore.documentType$,
      this.referenceStore.eiAutoEligibleCond$,
      this.referenceService.getLocations(),
      this.referenceStore.eiChildStatus$,
      this.referenceStore.documentStatus$,
    ]).subscribe(
      ([
        homeDistrict,
        languages,
        state,
        borough,
        fosterAgencies,
        relationships,
        eiDocumentTypes,
        eiAeConditions,
        agency,
        eiChildStatuses,
        documentStatuses,
      ]: [
          IReferenceData[],
          IReferenceData[],
          IReferenceData[],
          IReferenceData[],
          IReferenceData[],
          IReferenceData[],
          IReferenceData[],
          IReferenceData[],
          Location[],
          IReferenceData[],
          IReferenceData[]
        ]) => {
        this.eiReferenceData = {
          homeDistrict,
          languages,
          state,
          borough,
          fosterAgencies,
          relationships,
          eiDocumentTypes,
          eiAeConditions,
          agency,
          eiChildStatuses,
          documentStatuses,
        };
      }
    );
  }

  studentSearch(): void {
    this.formSubmitted = true;
    if (this.searchFormGroup.invalid) {
      this.searchFormGroup.markAllAsTouched();
      return;
    }
    this.emptySearchMsg = false;
    this.emptyStudentLink = false;
    this.toggle('');

    const studentObj: StudentSearchParams = {
      firstName: this.searchFormGroup.get('firstName')?.value,
      lastName: this.searchFormGroup.get('lastName')?.value,
      dateOfBirth: this.searchFormGroup.get('dob')?.value,
      grade: this.searchFormGroup.get('grade')?.value
        ? this.searchFormGroup.get('grade')?.value.value
        : '',
      schoolDBN: this.searchFormGroup.get('dbn')?.value?.description, //TODO pass list of DBNs to backend
      nycId: this.searchFormGroup.get('nycid')?.value
        ? this.searchFormGroup.get('nycid')?.value.toString()
        : '',
      isReferralSearch: this.newReferral,
      roleId: this.user?.selectedRole?.roleId,
      roleName: this.user?.selectedRole?.roleName,
    };

    if (
      studentObj.nycId.length === NYC_ID_LENGTH_SIX ||
      studentObj.nycId.length === NYC_ID_LENGTH_SEVEN ||
      studentObj.nycId.length === NYC_ID_LENGTH_NINE ||
      studentObj.firstName.length > STUDENT_FIRST_AND_LAST_NAME_LENGTH ||
      studentObj.lastName.length > STUDENT_FIRST_AND_LAST_NAME_LENGTH
    ) {
      this.students = [];
      this.loading = true;
      this.showResults = true;

      if (studentObj.dateOfBirth === '') {
        studentObj.dateOfBirth = null;
      }
      this.studentService.studentSearch(studentObj).subscribe({
        next: (response: StudentInfo[]) => {
          // add unique id for menu items. Actions should come from the API?
          if (
            this.showCreateLinkStudent === true &&
            response.length === this.responseLength
          ) {
            const payload: StudentSearchModel = {
              firstName: studentObj.firstName,
              lastName: studentObj.lastName,
              dob: studentObj.dateOfBirth
                ? moment(studentObj.dateOfBirth).format('YYYY-MM-DD')
                : null,
            };
            this.studentService.searchMSI(payload).subscribe({
              next: (msiResponse: StudentInfo[]) => {
                this.students = msiResponse.map(
                  (s: StudentInfo, index: number) => ({
                    ...s,
                    id: '' + index,
                  })
                );

                this.students = this.students.map((s: StudentInfo) => ({
                  ...s,
                  studentName: s.firstName + ' ' + s.lastName,
                  nycId: s.nycId,
                  dateOfBirth: this.formatDate.transform(s.birthDate),
                  gender: s.gender,
                  grade: includes(atsPreschoolGrades, s.grade)
                    ? 'Preschool'
                    : s.grade,
                  dateOfBirthUnixTimestamp: moment(s.dateOfBirth, '').valueOf(),
                }));
                this.loading = false;
                this.showCreate = this.canCreateStudent();
                this.cdref.detectChanges();
              },
              error: () => {
                this.loading = false;
                // Additional error handling logic if needed
              },
            });
          } else {
            this.students = response.map((s: StudentInfo, index: number) => ({
              ...s,
              id: '' + index,
            }));

            this.students = this.students.map((s: StudentInfo) => ({
              ...s,
              gender: s.gender,
              grade: includes(atsPreschoolGrades, s.grade)
                ? 'Preschool'
                : s.grade,
              dateOfBirthUnixTimestamp: moment(
                s.dateOfBirth,
                'MM/DD/YYYY',
                true
              ).valueOf(),
            }));
            this.loading = false;
            this.showCreate = this.canCreateStudent();
            this.cdref.detectChanges();
          }
        },
        error: () => {
          this.loading = false;
        },
      });
    } else {
      if (this.type !== 'createLinkStudent') {
        this.emptySearchMsg = true;
      } else {
        this.emptyStudentLink = true;
      }
    }
  }

  onHideHandler(): void {
    this.createForm();
    this.students = [];
    this.showResults = false;
    this.closeModal.next();
  }

  viewReferralRequestReevaluation(referralSk?: string, nycId?: string): void {
    this.router.navigate([
      'referrals/' +
      referralSk +
      '/' +
      nycId +
      '/view/request-for-reevaluation',
    ]);
  }

  viewReferralRequest(referralSk?: string, nycId?: string): void {
    const route: string =
      this.routesConstantService.routes.viewReferralsRequestPage;
    this.router.navigate([route], {
      queryParams: { Id: referralSk, nycId: nycId },
    });
    this.closeModal.next();
  }

  openStudentProfile(profile: StudentInfo): void {
    this.studentStore.initializeSelectedStudent(profile);
    this.router.navigate([
      this.routesConstantService.routes.studentInformationPage,
      profile.nycId,
    ]);
    this.closeModal.next();
  }

  addNewStudent(isEIstudent: boolean, studentSk?: string): void {
    // prepopulate student info from selectedStudent for EI
    if (!isEIstudent) {
      this.onHideHandler();
      this.showNewStudentDialog = true;
    } else {
      this.loading = true;

      this.eiTransitionService
        .GetEI(studentSk)
        .subscribe((response: EiAddStudent) => {
          this.loading = false;
          this.currentStudent = new EiAddStudent(
            response,
            this.eiReferenceData
          );
          this.onHideHandler();
          this.showNewStudentDialog = true;
        });
    }
  }

  restrictNumbers(event: KeyboardEvent): void {
    const pattern: RegExp = /^[a-zA-Z ]*$/;
    const inputChar: string = String.fromCharCode(event.keyCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  openInitReferralRequest(profile: StudentInfo): void {
    //if age < 3 and DOB month in 01-06 then referral can be created only after 10/01/birth year + 2
    //display “The child will be eligible for an Initial Referral starting October 1, xxxx”

    //if age < 3 and DOB month in 07-12 then referral can be created only after 04/01/birth year + 3
    //display “The child will be eligible for an Initial Referral starting April 1, xxxx”

    if (profile.dateOfBirth !== null) {
      const dob: Date = new Date(profile.dateOfBirth);
      const dobYear: number = dob.getFullYear();

      profile.isEI = this.isEISearch;
      this.studentStore.initializeSelectedStudent(profile);

      if (
        this.maxDOB <
        new Date(dobYear + THREE_YEARS, dob.getMonth(), dob.getDate())
      ) {
        const isEI: boolean =
          profile.eiId?.length === EI_ID_LENGTH_SIX ||
          profile.eiId?.length === EI_ID_LENGTH_SEVEN;
        if (dob.getMonth() < JULY) {
          const rDate: string = isEI ? SEPTEMBER_FOURTH : OCTOBER_FIRST;
          if (
            this.maxDOB <
            new Date(
              dobYear + TWO_YEARS,
              isEI ? SEPTEMBER : OCTOBER,
              isEI ? DAY_FOUR : DAY_ONE
            )
          ) {
            const errorMessage: string =
              CHILD_WILL_BE_ELIGIBLE_FOR_INITIAL_REFERRAL_STARTING_TEXT +
              rDate +
              (dobYear + TWO_YEARS);
            this.notificationService.show({
              content: errorMessage,
              hideAfter: 5000,
              position: { horizontal: 'center', vertical: 'top' },
              animation: { type: 'fade', duration: 400 },
              type: { style: 'error', icon: true },
            });
          } else {
            this.openInitialReferralRequest(profile);
          }
        } else {
          const rDate: string = isEI ? MARCH_FOURTH : APRIL_FIRST;
          if (
            this.maxDOB <
            new Date(
              dobYear + THREE_YEARS,
              isEI ? MARCH : APRIL,
              isEI ? DAY_FOUR : DAY_ONE
            )
          ) {
            const errorMessage: string =
              CHILD_WILL_BE_ELIGIBLE_FOR_INITIAL_REFERRAL_STARTING_TEXT +
              rDate +
              (dobYear + THREE_YEARS);
            this.notificationService.show({
              content: errorMessage,
              hideAfter: 5000,
              position: { horizontal: 'center', vertical: 'top' },
              animation: { type: 'fade', duration: 400 },
              type: { style: 'error', icon: true },
            });
          } else {
            this.openInitialReferralRequest(profile);
          }
        }
      } else {
        this.openInitialReferralRequest(profile);
      }
    } else {
      this.notificationService.show({
        content: DATE_OF_BIRTH_MISSING,
        hideAfter: 600,
        position: { horizontal: 'center', vertical: 'top' },
        animation: { type: 'fade', duration: 400 },
        type: { style: 'error', icon: true },
      });
    }
  }

  openInitialReferralRequest(profile: StudentInfo): void {
    const route: string =
      this.routesConstantService.routes.newReferralsRequestPage;
    this.router.navigate([`${route}/${profile?.nycId}`]);
    this.closeModal.next();
  }

  openM3YReeval(data: StudentActions): void {
    this.router.navigate([
      this.routesConstantService.routes.evaluations +
      data?.referralSk +
      '/' +
      data?.nycId +
      '/add/pwn/three-year-reevaluation',
    ]);
    this.closeModal.next();
  }

  waiveM3YReeval(data: StudentInfo): void {
    this.router.navigate([
      this.routesConstantService.routes.evaluations +
      data?.referralSk +
      '/' +
      data?.nycId +
      '/add/pwn/parent-waiver-three-year-reevaluation',
    ]);
    this.closeModal.next();
  }

  initiateRequestForRevaluation(data: StudentInfo): void {
    const referralType: number = data?.isM3Y
      ? ReferralType.Mandate3Year
      : data.hasRRE
        ? ReferralType.RequestForAdditionalReevaluation
        : ReferralType.RequestForReevaluation;
    if (data?.hasEvals) {
      this.notificationService.show({
        content:
          referralType === ReferralType.Mandate3Year
            ? OUTSTANDING_ASSESSMENTS_TEXT +
            MANDATED_THREE_YEAR_REEVALUATION_TEXT
            : referralType === ReferralType.RequestForAdditionalReevaluation
              ? OUTSTANDING_ASSESSMENTS_TEXT + NEW_ADDITIONAL_REEVALUATION_TEXT
              : OUTSTANDING_ASSESSMENTS_TEXT + NEW_REEVALUATION,
        hideAfter: dialogTimer,
        position: { horizontal: 'center', vertical: 'top' },
        animation: { type: 'fade', duration: 400 },
        type: { style: 'error', icon: true },
      });
    } else {
      this.router.navigate(
        [
          this.routesConstantService.routes.referrals +
          data.nycId +
          '/add/request-for-reevaluation',
        ],
        {
          queryParams: { referralType: referralType },
        }
      );
    }
    this.closeModal.next();
  }

  canCreateStudent(): boolean {
    return some(
      this.user?.permissions,
      (x: Permission) => x.permissionId === Permissions.CanCreateStudent
    );
  }
}
